import { PaginationFilterRequest } from "./core.model";

export interface EncyclopediaItem {
  id: number;
  name: string;
  description: string;
  imageUrl: string;
  type: EncyclopediaTypeEnum;
}

export interface UpsertEncyclopediaItem {
  id?: number;
  name?: string;
  description?: string;
  imageUrl?: string;
  type?: EncyclopediaTypeEnum;
}

export class EncyclopediaItemPaginationFilterRequest extends PaginationFilterRequest{  
  storyId?: number;
  storyChapterId?: number;
  type?: EncyclopediaTypeEnum;
}

export enum EncyclopediaTypeEnum
{
    Person = 1,
    Creature = 2,
    Location = 3,
    Item = 4,
}
export const EncyclopediaTypeList = [
  {value: 1, label: "Person"},
  {value: 2, label: "Creature"},
  {value: 3, label: "Location"},
  {value: 4, label: "Item"},
];